import React, { useState } from "react";
import { feedback } from "./helper";
import AddressModal from "./AddressModal";
import { t } from "../../utils/i18n";

const VerificationStatus = ({
  legacy,
  verification_started,
  active_verification,
  verification_accepted,
  verificationPath,
  startVerificationPath,
  isAddressMissing,
  user_kyc_detail,
  ...props
}) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [canStartVerification, setCanStartVerification] = useState(
    user_kyc_detail
  );
  const openModal = (e) => {
    e.preventDefault();

    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);

  const isPendingVerification = !!(legacy || verification_started);

  return (
    <>
      <div className="verification-container">
        <div className="verification-step active">
          <div className="verification-circle"></div>
          <div className="step-content">
            <div className="step-title">{t("account.verification.start_title")}</div>
            <div className="step-description">
              {t("account.verification.start_desc")}
            </div>
            {!canStartVerification && (
              <a
                role="button"
                href="#"
                className="btn btn-primary btn-large verify-btn mt-4"
                onClick={(e) => openModal(e)}
              >
              {t("account.verification.add_details")} <i className="fa fa-arrow-right"></i>
              </a>
            )}
            {!active_verification && canStartVerification && (
              <a
                role="button"
                href={startVerificationPath}
                className="btn btn-primary btn-large verify-btn mt-4"
              >
                {t("account.verification.verify_account")} <i className="fa fa-arrow-right"></i>
              </a>
            )}
          </div>
          <div
            className={`vertical-line ${
              isPendingVerification && "verification-active-item"
            }`}
          ></div>
        </div>
        <div className="verification-step">
          <div
            className={`verification-circle ${
              isPendingVerification && "verification-active-item"
            }`}
          ></div>
          <div className="step-content">
            <div className="step-title">{t("account.verification.submit_title")}</div>
            <div className="step-description">
              {t("account.verification.submit_desc")}
            </div>
            {feedback(props)}
            {!verification_accepted &&
              (legacy || verification_started) &&
              canStartVerification && (
                <a
                  role="button"
                  href={verificationPath}
                  className="btn btn-primary btn-large verify-btn mt-1"
                >
                  {t("account.verification.go_to")}{" "}
                  <i className="fa fa-arrow-right"></i>
                </a>
              )}
          </div>
          <div
            className={`vertical-line ${
              verification_accepted && "verification-active-item"
            }`}
          ></div>
        </div>
        <div className="verification-step">
          <div
            className={`verification-circle ${
              verification_accepted && "verification-active-item"
            }`}
          ></div>
          <div className="step-content">
            <div className="step-title">{t("account.verification.submitted_title")}</div>
            <div className="step-description">
              {t("account.verification.submitted_desc")}
            </div>
            {verification_accepted && (
              <>
                <div className="alert alert-success verification-alert verification-alert-success mt-4">
                  <i className="fa fa-info-circle"></i> {t("account.verification.accepted")}
                </div>
                <a
                  role="button"
                  href="/add_funds"
                  className="btn btn-primary btn-large verify-btn mt-1"
                >
                  <i className="fa fa-plus"></i> {t("account.verification.add_funds")}
                </a>
              </>
            )}
          </div>
        </div>
      </div>
      <AddressModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        verificationId={active_verification?.id}
        setCanStartVerification={setCanStartVerification}
        kycDetail={user_kyc_detail}
      />
    </>
  );
};

export default VerificationStatus;
